(function() {
    'use strict';

    // Workaround for Edge 16+, which only implemented object-fit for <img> tags
    // TODO: Keep an eye on Edge to determine which version has full final support
    let edgeVersion = window.navigator.userAgent.match(/Edge\/(\d{2})\./);
    let edgePartialSupport = edgeVersion
        ? parseInt(edgeVersion[1], 10) >= 16
        : false;

    // If the browser does support object-fit, we don't need to continue
    let hasSupport = 'objectFit' in document.documentElement.style;
    if (hasSupport && !edgePartialSupport) {
        window.objectFitPolyfill = function() {
            return false;
        };
        return;
    }

    // Not a beauty but so is IE11
    document.querySelectorAll('[data-object-fit]').forEach((item) => {
        item.parentElement.style.backgroundImage = 'url('+item.src+')';
        item.style.visibility = 'hidden';
    });

})();
